export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

export const GRAPHQL_URL =
  process.env.REACT_APP_GRAPHQL_URL || "http://localhost:8080/v1/graphql";

export const GRAPHQL_WS_URL =
  process.env.REACT_APP_GRAPHQL_WS_URL || "ws://localhost:8080/v1/graphql";
